<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="-" :loginShow="loginShow" :gotoIndex="gotoIndex"></headers>
          <div class="position2">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <span>个人中心</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div class="wraper">
          <div class="personal">
            <personal pageType="appointment"></personal>
            <div class="personal_right">
              <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign4.png"> 我的预约列表</span></h2>
              <div style="width: 100%;" v-if="appointment_list && appointment_list.length>0">
              <el-card class="box-card" shadow="hover"
                       style="width: 96%;margin-left: 20px;margin-top: 10px;font-size: 14px;"
                       v-for="(item,index) in appointment_list" :key="index"
              >
                <div slot="header" class="clearfix">
                  <span><span style="font-weight: 600">{{item.dutyDate}}</span>
                  <span>【 <span v-if="item.status==0" style="color: red">待取号</span>
                    <span v-if="item.status==1" >{{item.statusName}}</span>
                    <span v-if="item.status==2" style="color: green">{{item.statusName}}</span>
                    <span v-if="item.status==3" style="color: blue">{{item.statusName}}</span>
                    <span v-if="item.status==4" >{{item.statusName}}</span>
                    <span v-if="item.status==98" style="color: orchid">{{item.statusName}}</span>
                    <span v-if="item.status==99" style="color: orange">{{item.statusName}}</span>】
                  </span>
                  </span>
                  <el-button type="primary" style="float: right; padding: 5px;font-size: 12px;"  v-if="item.status==0"  @click="cancelAppointment(item.atId)">取消预约</el-button>
                  <el-button type="primary" style="float: right; padding: 5px;font-size: 12px;"  v-if="item.status!=0" disabled  @click="cancelAppointment(item.atId)">取消预约</el-button>
                  <el-button type="primary" style="float: right; padding: 5px;font-size: 12px;margin-right: 5px"  v-if="item.type=='services'"   @click="dataInfoss(item.atId,item.serviceCode,item.serviceName)">其他信息</el-button>
                </div>
                <div class="text item" style="line-height: 23px;" >
                  <div style="display: flex;justify-content: left;">
                    <div style="width:300px;"><span class="yy_title">预约业务：</span><span class="yy_title_content">{{item.serviceName}}</span></div>
                    <div><span class="yy_title">联系电话：</span><span class="yy_title_content">{{item.tel}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div style="width:300px;"><span class="yy_title">办事单位：</span><span class="yy_title_content">{{item.partyName}}</span></div>
                    <div><span v-if="item.dutyTimeStr !=null" class="yy_title">预约时段：</span><span class="yy_title_content">{{item.dateType}}&nbsp;{{item.dutyTimeStr}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;" >
                    <div><span class="yy_title">办公地址：</span><span class="yy_title_content">{{item.address}}</span></div>
                  </div>
                  <div style="display: flex;justify-content: left;">
                    <div><span class="yy_title">预约说明：</span><span class="yy_title_content">{{item.atRemark}}</span></div>
                  </div>
                </div>
              </el-card>
              </div>
              <div v-else>
                <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);margin-top: 50px;">
                  <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                  <div>暂无数据</div>
                </div>
              </div>
              <div style="line-height: 35px;">
                <el-dialog  :visible.sync="contentShow" width="600px" >
                  <div>
                    <a style="font-weight: 800"></a><a>{{titleName}}-其他信息</a>
                  </div>
                 <div v-if="dataInfoList.length>0">
                   <div v-for="(item,index) in dataInfoList">
                     <span  v-if="item.rowType=='1'">{{item.rowName}}：</span>
                     <span v-else>
                         <el-divider content-position="left">{{item.rowName}}</el-divider>
                     </span>
                     <span>{{item.rowValue}}</span>
                   </div>
                 </div>

                  <div v-else>
                    <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
                      <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                      <div>暂无数据</div>
                    </div>
                  </div>
                </el-dialog>
              </div>
              <div style="width: 100%;height: 50px;">&nbsp;</div>
              <div class="clear"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  import personal from "../../components/Personal";
  export default {
    name: "Appointment",
    components: {
      headers, fixedDiv, footers,personal
    },
    data() {
      return {
        titleName:'',
        appointment_list: [],
        dataInfoList: [],
        loginShow:false,
        contentShow:false,
        gotoIndex:false,
      }
    },
    mounted() {
      var userInfo=this.$cookies.get('userInfo')
      if(!userInfo || userInfo.userId =='' || userInfo.userId ==-1){
        this.loginShow=true;
        this.gotoIndex=true;
      }
      this.getListData();
    },
    methods: {
      getListData() {
        this.$https.post("/api/appointment/getAppointAllMentInfo.do", {}, response => {
          if (response.status === 200 && response.data.code === 200) {
            if (!this.$util.isEmpty(response.data.data)) {
              //取消预约的不要
              this.appointment_list = response.data.data.filter(bean=>{
                return bean
                // return bean.status!==99
              });
            }
          }
        });
      },
      //取消预约
      cancelAppointment(appoint_id){
        this.$confirm('您确定要取消本次预约吗？<br />说明：每天最多取消三次预约，超过将被禁止预约！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          dangerouslyUseHTMLString:true,
          type: 'warning'
        }).then(() => {
          //发送请求，取消预约
          this.$https.post("/api/appointment/outAppointMent.do", {atId:appoint_id}, response => {
            if (response.status === 200 && response.data.code === 200) {
              this.$message({
                type: 'success',
                message: '取消预约成功!'
              });
              //重新加载数据
              this.getListData()
            }else {
              this.$message({
                type: 'error',
                message: '取消预约失败!'
              });
            }
          });
        }).catch(()=>{});
      },
      dataInfoss(atId,serviceCode,name){
        this.titleName=name
        var t=this;
        this.$https.post("api/ywt/getServicesAppointmentChileInfo.do",{atId:atId,serviceCode:serviceCode},response=>{
          if (response.status === 200 && response.data.code===200 && response.data.data && response.data.data.data) {
            t.dataInfoList=response.data.data.data;
            t.contentShow=true;
          } else {
            this.$message.error('网络异常，请稍后重试!');
          /*  t.$toast.fail({
              message: '网络异常，请稍后重试!',
              forbidClick: true,
              duration:2500
            });*/
          }
        })

      },
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      },
      getAppointStatus(item){
        if (item>=0){
          return item.statusName;
        }else{
          return '预约成功'
        }
      }
    }
  }
</script>

<style>
  .personal_right .el-card__header {
    padding: 9px 20px;
    border-bottom: 1px solid #EBEEF5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #f7f7f7;
  }
  .yy_title{
    font-size: 12px;
  }
  .yy_title_content{
    font-size: 12px;
    color: #909399;
  }
</style>



// WEBPACK FOOTER //
// src/pages/personal/Appointment.vue